export const errosSelector = state => state.authentication.errors;
export const successSelector = state => state.authentication.success;
export const tokenSelector = state => state.authentication.token;
export const userSelector = state => state.authentication.user;
export const twoSelector = state => state.authentication.twofa;
